require('core-js/features/string/replace-all')
